import { get, writable } from "svelte/store";
import { getDistance } from "geolib";
import journey, { journeySubscribeThrottled } from "./journey.js";
import { food as foodAt } from "../api/api.js";
import windows from "./windows.js";

const MINIMUM_DISTANCE_INTERVAL_METERS = 5000;

function createFoodStore() {
    const store = writable({
        all: [],
        indexForCurrent: undefined,
        isLoading: false
    });

    const { subscribe, update } = store;

    let lastUpdatedAt;
    let isEnabled = false;

    function updateFood(location) {
        update((state) => ({
            ...state,
            isLoading: true
        }));

        foodAt(location)
            .then(({ food }) => {
                if (food) {
                    update((state) => {
                        const isSameFood =
                            state.all.length > 0 &&
                            !!state.all.find(({ name }) => name === food.name);

                        if (isSameFood) {
                            return state;
                        }

                        return {
                            ...state,
                            all: [...state.all, food],
                            indexForCurrent: state.isPaused
                                ? Number.isFinite(state.indexForCurrent)
                                    ? state.indexForCurrent
                                    : state.all.length
                                : state.all.length,
                            isLoading: false
                        };
                    });
                } else {
                    update((state) => ({
                        ...state,
                        isLoading: false
                    }));
                }
            })
            .catch((error) => {
                console.warn("failed to fetch food", error.message);

                update((state) => ({
                    ...state,
                    isLoading: false
                }));
            });
    }

    journeySubscribeThrottled(8000, ({ location }) => {
        const shouldUpdate =
            location &&
            (lastUpdatedAt === undefined ||
                getDistance(lastUpdatedAt, location) >
                    MINIMUM_DISTANCE_INTERVAL_METERS) &&
            windows.isOpen("food");

        if (!shouldUpdate) {
            return;
        }

        lastUpdatedAt = location;

        updateFood(location);
    });

    windows.onOpen("food", function didOpenWindow() {
        const shouldUpdate = get(store).all.length === 0;

        if (shouldUpdate) {
            updateFood(get(journey).location);
        }
    });

    return {
        subscribe,

        previous() {
            update((state) => ({
                ...state,
                indexForCurrent: Math.max(state.indexForCurrent - 1, 0)
            }));
        },

        next() {
            update((state) => ({
                ...state,
                indexForCurrent: Math.min(
                    state.indexForCurrent + 1,
                    state.all.length - 1
                )
            }));
        },

        pause() {
            update((state) => ({
                ...state,
                isPaused: true
            }));
        },

        resume() {
            update((state) => ({
                ...state,
                isPaused: false
            }));
        },

        enable() {
            isEnabled = true;
        },

        disable() {
            isEnabled = false;
        }
    };
}

const food = createFoodStore();

export default food;
